var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"box"},[_c('div',{staticClass:"img_box"},[_c('img',{attrs:{"src":require("@/assets/image/liability/error.png")}})]),_c('div',{staticClass:"title"},[_vm._v("健康或职业评估不通过")]),_c('div',[_vm._v("非常抱歉，该被保险人未能通过本次投保审核")])])])
}]

export { render, staticRenderFns }